export const flyoutResaleSingleFieldFormDebounceTime = 40

export const standardResellerAgreementUrl =
  'https://assets.flyout.labra.io/standard_and_enterprise_eula/Reseller-Contract-for-AWS-Marketplace-2021-12-01.pdf'

export const disableResaleAuthorizationDurationText =
  '(Only single use resale authorization are supported for flexible payment schedule option.)'

export const disableResaleFlexiblePayment =
  '(FPS is not supported for the subscription product type)'
